import { render, staticRenderFns } from "./BudgetEditDialog.vue?vue&type=template&id=373a8685&"
import script from "./BudgetEditDialog.vue?vue&type=script&lang=js&"
export * from "./BudgetEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports